import { render, staticRenderFns } from "./FormSubmissionsView.vue?vue&type=template&id=d35ee388&scoped=true&lang=pug&"
import script from "./FormSubmissionsView.vue?vue&type=script&lang=ts&"
export * from "./FormSubmissionsView.vue?vue&type=script&lang=ts&"
import style0 from "./FormSubmissionsView.vue?vue&type=style&index=0&id=d35ee388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35ee388",
  null
  
)

export default component.exports